@if (configurationWithAdditionalFields().length) {
  <mat-expansion-panel expanded class="configure-filters-of-a-mode-panel">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon class="me-2 material-icons-outlined">filter_alt</mat-icon>
        {{
          modeName() === 'default'
            ? ('system.dialogSection.filters' | translate)
            : ('filterModeName.' + modeName() | translate)
        }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    @for (configuration of configurationWithAdditionalFields(); track configuration.inputsConfiguration.fixedField!) {
      @let isSuppressed =
        filterSuppression() | arrayIncludes: configuration.inputsConfiguration.fixedField! : filterSuppression().length;

      <div class="d-flex gap-10 align-items-center">
        @if (!configuration.isRequired) {
          <mat-checkbox
            [style.flex]="0"
            [checked]="!isSuppressed"
            (change)="toggleCheck(configuration.inputsConfiguration.fixedField!)"
          ></mat-checkbox>
        }

        <advanced-filter-inputs
          [disabled]="isSuppressed"
          [style.flex]="1"
          [class.required-filter]="configuration.isRequired && !areAllFieldsRequired()"
          [isOptional]="true"
          [dataForWidgetSpecificConfiguration]="{
            widgetType: widgetType(),
            typeBasedConfiguration: typeBasedConfiguration(),
            selectedFilterMode: modeName(),
          }"
          [inputsConfiguration]="configuration.inputsConfiguration"
          [selectedFilterIdentity]="configuration.selectedFilterIdentity()"
          (autoSubmit)="configuration.submitData.set($event)"
        ></advanced-filter-inputs>
      </div>
    }

    <div class="d-flex align-items-center gap-5 mt-2">
      <app-info-message
        icon="auto_awesome"
        text="{{ 'page.widgetContent.addEditDialog.emptyFilterDisclaimer' | translate }}"
      ></app-info-message>
    </div>
  </mat-expansion-panel>
}
